export const validate = values => {
  const errors = {}

  if (!values.domain) {
    errors.domain = 'Domain is required'
  }

  if (!values.entityId) {
    errors.entityId = 'Entity ID is required'
  }

  if (!values.idpUrl) {
    errors.idpUrl = 'IDP URL is required'
  } else if (!/^https?:\/\/.+/.test(values.idpUrl)) {
    errors.idpUrl = 'IDP URL must be a valid URL'
  }

  if (!values.certificate) {
    errors.certificate = 'Certificate is required'
  }

  return errors
}
